import React, { createContext, useEffect, useState, useContext, useRef } from "react";
import { useDispatch } from "react-redux";

import { browserHistory } from "@common/helpers/browserHistory";
import { getAllTickets } from "@tickets/helpers/addTicketByType";
import { PopupContext } from "@app/dev/contexts/popup";
import { POPUPS } from "@common/constants/popups";
import IdleService from "@common/services/idle";
import Config from "@skin_config";

const initialState = {
  sport: [],
  deposit: [],
  casino: []
}

export const TicketsContext = createContext({});

let _dispatcher, _state;
export const getTicketsState = () => _state;

export const getTicketsDispatcher = () => _dispatcher;

export const TicketsContextProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [{ closePopupByType }] = useContext(PopupContext);
  const [sportList, setSportList] = useState(initialState);

  _dispatcher = setSportList;
  _state = sportList;

  useEffect(() => {
    const allTickets = getAllTickets(sportList);

    if (!allTickets.length) return;

    const clearListener = IdleService.ifInactive(60, () => {
      closePopupByType(POPUPS.TICKET_DETAILS_POPUP);
      setSportList(initialState);
      {
        Config.main.enableTicketPopupFlow && getAllTickets(sportList).length && browserHistory.push("/betting/prematch");
      }
    });

    return clearListener;
  }, [dispatch, sportList, closePopupByType]);

  const resetState = () => setSportList(initialState)

  return <TicketsContext.Provider value={[sportList, setSportList, resetState]}>{children}</TicketsContext.Provider>;
};
